/**
 * 글로릴스(gloreels) SSO 연동 상수.
 * 서버 명세: documents/gloreels-sodu-integration-master.md §3
 */

/**
 * 글로릴스 연동 킬스위치 — VITE_APP_GLOREELS_URL 이 명시된 빌드에서만 켜진다.
 *
 * 운영(.env.production)에만 넣고 dev 배포(.env.development)에는 넣지 않는다:
 * dev 소듀의 토큰은 운영 글로릴스에서 어차피 검증 불가(다른 플로잉 백엔드)라,
 * 켜두면 dev 사용자가 운영으로 리다이렉트됐다 튕기는 쓰레기 트래픽만 생긴다.
 * 로컬 개발은 .env.development.local(git 미추적)로 켠다.
 */
const RAW_GLOREELS_URL = (process.env.VITE_APP_GLOREELS_URL as string | undefined)?.replace(/\/$/, '');

/**
 * SSO 를 켤 수 있는 호스트 — 글로릴스의 SSO_PEER_ORIGINS 화이트리스트와 맞춘다.
 *
 * 이 앱은 partner.sodomall.store 등 여러 도메인을 함께 서빙하는데, 화이트리스트 밖
 * 호스트에서 eager 전파가 뜨면 글로릴스 from-sodu 가 return_to 를 버리고 복귀지를
 * 자기 /home 으로 바꿔버려 사용자가 소듀로 돌아오지 못한다 — 소도몰 파트너의
 * "로그인 → 글로릴스로 튕김 → 재로그인" 무한 루프의 원인 (2026-09-02).
 * 글로릴스 쪽에 오리진을 추가하면 여기에도 같이 추가할 것.
 */
const SSO_HOSTS = [
    'studio.sodu.pro',
    'studio.flowing.space',
    'studio.dev.sodu.pro',
    'studio.dev.flowing.space',
    'localhost',
];

export const GLOREELS_SSO_ENABLED: boolean =
    !!RAW_GLOREELS_URL && SSO_HOSTS.includes(window.location.hostname);

/** 글로릴스 오리진 — 비활성 빌드에서도 상수 자체는 안전한 기본값을 가진다 */
export const GLOREELS_ORIGIN: string = RAW_GLOREELS_URL || 'https://gloreels.com';

/** 글로릴스 SSO 착지 경로 (코드는 fragment 로 전달) */
export const GLOREELS_SSO_ENTER = `${GLOREELS_ORIGIN}/sso/enter`;

/** 글로릴스 API */
export const GLOREELS_API = {
    fromSodu: `${GLOREELS_ORIGIN}/api/sso/from-sodu`,
    redeem: `${GLOREELS_ORIGIN}/api/sso/redeem`,
    redeemLogout: `${GLOREELS_ORIGIN}/api/sso/redeem-logout`,
    logout: `${GLOREELS_ORIGIN}/api/sso/logout`,
    status: `${GLOREELS_ORIGIN}/api/sso/status`,
    unlink: `${GLOREELS_ORIGIN}/api/sso/unlink`,
} as const;
